import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";
import { AxnCompany, AxnRelyingParty } from "@idw-types/data/reference-data/axn";
import { FormattedMessagingTemplateConfiguration, MessagingTemplateConfiguration } from "@idw-types/data/messaging-template";

export const formatMessagingTemplateConfigurations = (
    messagingTemplates: Array<MessagingTemplateConfiguration>,
    companies: Array<AxnCompany>,
    relyingParties: Array<AxnRelyingParty>
): Array<FormattedMessagingTemplateConfiguration> => {
    return messagingTemplates.map(mt => formatMessagingTemplateConfiguration(mt, companies, relyingParties));
};

export const formatMessagingTemplateConfiguration = (
    messagingTemplate: MessagingTemplateConfiguration,
    companies: Array<AxnCompany>,
    relyingParties: Array<AxnRelyingParty>
): FormattedMessagingTemplateConfiguration => {
    const company = companies.find(c => c.id === messagingTemplate.companyID);
    const relyingParty = relyingParties.find(rp => rp.id === messagingTemplate.relyingPartyID);

    const languages = (messagingTemplate.languages || "").split(",") as Array<LocaleTypes>;

    let dateCreated = null;
    if (messagingTemplate.dateCreated) {
        dateCreated = new Date(parseInt(messagingTemplate.dateCreated));
    }

    let dateLastModified = null;
    if (messagingTemplate.dateLastModified) {
        dateLastModified = new Date(parseInt(messagingTemplate.dateLastModified));
    }

    return {
        id: messagingTemplate.id,
        uuid: messagingTemplate.uuid,
        name: messagingTemplate.name,
        status: messagingTemplate.status,
        type: messagingTemplate.type,
        languages,
        company,
        relyingParty,
        dateCreated,
        dateLastModified,
        permissions: messagingTemplate.permissions
    };
};